import { Lock, Ticket } from "lucide-react";

export const Logo = () => {
  return (
    <div className="relative inline-flex items-center justify-center">
      <div className="relative w-16 h-16 flex items-center justify-center animate-float">
        {/* Glow effect */}
        <div className="absolute inset-0 bg-primary/20 blur-xl animate-glow rounded-full" />
        
        {/* Ticket icon */}
        <Ticket 
          className="w-10 h-10 text-primary absolute z-10" 
          strokeWidth={2}
        />
        
        {/* Lock icon overlay */}
        <Lock 
          className="w-5 h-5 text-accent absolute z-20 -bottom-1 -right-1" 
          strokeWidth={2.5}
        />
      </div>
    </div>
  );
};
